import { Container, Button } from "react-bootstrap";
import IconButton from "../../common/IconButton";
import Search from "../buscador/Search";
import { useEffect, useState, useContext } from "react";
import getDatos from "../../../services/getDatos";
import guardarUbicacion from "../../../services/guardarUbicacion";
import { useNavigate } from "react-router-dom";

// context geomedellin
import contextGeomedellin from "../../../context/contextGeomedellin";

//components
import Load from "../../common/Load";
import Migas from "../../../components/view/migasGeomedellin/Migas";
import Card from "../../view/card/Card";
import consultarInfoToken from "../../../services/consultarInfoToken";

// icons
import { MdPhonelink } from "react-icons/md";

// Varibales ENVIRONMENT
import { URL_IMAGE_GEOMEDELLIN } from "../../../environment";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";

// Hooks auth
import { usePermisions } from "../../../hooks/usePermisions";
import encode64 from "../../../helpers/encode64";

// Edit img banner
import { MdOutlineModeEdit } from "react-icons/md";
import { UploadFileIcon } from "../../common/UploadFileIcon";

export default function LoMasReciente({ idComponente, caractFiltro }) {
  const navigate = useNavigate();

  const [infoHome, setInfoHome] = useState([]);

  const [rowPerPage, setRowPerPage] = useState(9);

  const [load, setLoad] = useState(false);

  const {
    componentes,
    buscadorHoriBool,
    restablecerEstilos,
    setBuscadorHoriBool,
  } = useContext(contextGeomedellin);

  const [visitas, setVisitas] = useState(0);

  const [dataBuscadorHori, setDataBuscadorHori] = useState([]);

  const [totalRowsGlobal, setTotalRowsGlobal] = useState(0);

  const { permissions } = usePermisions(idComponente);
  const [tipoMasReciente, setTipoMasReciente] = useState([]);

  useEffect(() => {
    let datos;
    if (localStorage.getItem("superAdmin") === "true") {
      datos = infoHome?.resultRecienteSuperAdmin;
    } else {
      datos = infoHome?.resultRecienteImg;
    }
    setTipoMasReciente(datos);
  }, [infoHome]);

  //console.log(caractFiltro);

  useEffect(() => {
    const listarInfoHome = async () => {
      setLoad(true);
      try {
        let infoToken = await consultarInfoToken();
        const infoHome = await getDatos("atributos/infohome", {
          info: encode64(JSON.stringify(infoToken)),
        });
        setInfoHome(infoHome);
        setVisitas(infoHome.resultVisitas?.[0]?.visitas);
      } catch (err) {
        console.log("error al listar los datos del home");
      } finally {
        setLoad(false);
      }
    };
    listarInfoHome();
    restablecerEstilos();
    return () => {
      setBuscadorHoriBool(false);
      setDataBuscadorHori([]);
    };
  }, []);

  const redireccionCard = (vinculo) => {
    if (vinculo) {
      window.open(vinculo, "_blank");
    } else {
      return false;
    }
  };

  const mostrarImagenReciente = (reciente) => {
    const { fk_id_componente, imagen, imagen_banco } = reciente;

    if (fk_id_componente === 3) {
      return `${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Iconos/${
        reciente.imagen?.split(".")[1]
      }.jpg`;
    }

    if (imagen?.includes("https://www.medellin.gov.co/")) {
      return imagen;
    }

    if (imagen) {
      return `${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/${reciente.nombre_carpeta}/${reciente.id_elemento}/${reciente.imagen}`;
    }

    if (imagen_banco) {
      return `${reciente.imagen_banco}`;
    }

    return `${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/${reciente.nombre_carpeta}/${reciente.id_elemento}/${reciente.imagen}`;
  };

  const renderImagenBanner = () => {
    if (!buscadorHoriBool) {
      let styleImagen = "";

      if (
        "resultSqlHome" in caractFiltro &&
        caractFiltro?.resultSqlHome[0]?.imagen
      ) {
        styleImagen = `linear-gradient(
          180deg,
          rgba(255, 255, 255, 1) 20%,
          rgba(255, 255, 255, 0.4) 50%
        ), url("${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Banner/${idComponente}/${caractFiltro.resultSqlHome[0].imagen}")`;
      } else {
        styleImagen = `linear-gradient(
            180deg,
            rgba(255, 255, 255, 1) 20%,
            rgba(255, 255, 255, 0.4) 50% ), url("../icons/Banner-home.png");`;
      }

      return styleImagen;
    }

    return "none";
  };

  useEffect(() => {
    if (!buscadorHoriBool) {
      setRowPerPage(9);
    }
  }, [buscadorHoriBool]);

  if (load) {
    return (
      <>
        <Load visible={load} />
      </>
    );
  }

  return (
    <>
      <Container fluid={true} className="content-principal">
        <Container
          fluid={true}
          className={buscadorHoriBool ? "search-result_global" : "img-home"}
          style={{ backgroundImage: renderImagenBanner() }}
        >
          {permissions.superAdmin ? (
            <div className="edit-banner">
              <UploadFileIcon
                icon={<MdOutlineModeEdit color="#fff" size={"20px"} />}
                idComponente={idComponente}
              />
            </div>
          ) : null}
          {buscadorHoriBool && <Migas ruta={"Resultados de la búsqueda"} />}
          <Search
            position={"horizontal"}
            element={idComponente}
            caractFiltro={caractFiltro}
            setDataBuscadorHori={setDataBuscadorHori}
            setTotalRowsGlobal={setTotalRowsGlobal}
            rowPerPage={rowPerPage}
          />
        </Container>
        {buscadorHoriBool ? (
          <>
            <div className="content-result-busqueda">
              <div className="">
                <label class="lbl-contentdestacado ">Resultados </label>
                <label class="lbl-contentdestacadosimple ml-5">
                  de la búsqueda
                </label>
                <div class="content-tematicasborder">
                  <label class="lbl-destacadosborder-b-h"></label>
                </div>
              </div>
              {dataBuscadorHori.length > 0 ? (
                <>
                  <Card component={0} data={dataBuscadorHori} />
                  {totalRowsGlobal > 9 && (
                    <div className="flex-cargar_mas">
                      <p
                        className="pagination-global"
                        onClick={() => {
                          setRowPerPage((prev) => prev + 9);
                        }}
                      >
                        Cargar más
                      </p>
                    </div>
                  )}
                </>
              ) : (
                <div className="flex-msg_noResults">
                  <h2>No se han encontrado resultados para tu búsqueda.</h2>
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            <div className="grid-lomasReciente">
              {infoHome?.resultNoticias?.length > 0 ? (
                <Container className="content-noticias">
                  <div className="content-detacados-hijo">
                    <label className="lbl-contentdestacado ">Últimas </label>
                    <label className="lbl-contentdestacadosimple ml-5">
                      Noticias
                    </label>
                    <div className="content-tematicasborder">
                      <label className="lbl-destacadosborder"></label>
                    </div>
                  </div>
                  <div className="espacio-tarjetas-destacados">
                    <Swiper
                      navigation={true}
                      modules={[Navigation]}
                      slidesPerView={1}
                    >
                      {infoHome?.resultNoticias?.map((noticia, index) => {
                        return (
                          <SwiperSlide key={noticia.id}>
                            <Container className="content-tarjetas-noticias">
                              <div className="col-7 content-lbl-titulo-destacados">
                                <div>
                                  <p className="p-titulo-tarjeta-noticias">
                                    {noticia?.nombre}
                                  </p>
                                  <p className="p-tipo-destacado">
                                    {noticia?.tipo}
                                  </p>
                                  <p
                                    className="p-descripcion-tarjeta-noticias"
                                    title={noticia.descripcion}
                                  >
                                    {noticia?.descripcion}
                                  </p>
                                </div>
                                <div className="div-ultima-noticia-continuar">
                                  <Button
                                    className="btn-ira-tarjeta"
                                    onClick={() => {
                                      redireccionCard(noticia.vinculo);
                                      guardarUbicacion("7", "2", noticia.id);
                                    }}
                                  >
                                    CONTINUAR LEYENDO
                                  </Button>
                                  <div className="">
                                    <a href="/geomedellin/noticias">
                                      Más noticias
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <div className="col-5 img-tarjeta-noticias">
                                <img
                                  src={`${noticia.imagen}`}
                                  className="top-img-noticia"
                                  alt={noticia.imagen}
                                />
                              </div>
                            </Container>
                          </SwiperSlide>
                        );
                      })}
                    </Swiper>
                  </div>
                </Container>
              ) : (
                ""
              )}

              <Container className="container-back-dark content-lomasreciente">
                <div className="content-lomasreciente-hijo">
                  <label className="lbl-lomasreciente">Lo más reciente</label>
                  <div className="content-tematicasborder">
                    <label className="lbl-tematicasborde"></label>
                  </div>
                </div>
                <div className="flex-listreciente mt-4">
                  {tipoMasReciente?.length > 0
                    ? tipoMasReciente?.map((reciente, index) => {
                        return (
                          <div
                            className="content-listadestacado"
                            key={"destacado-" + index}
                            onClick={() => {
                              navigate({
                                pathname: reciente.url_componente,
                                search: `?id=${reciente.id_elemento}`,
                              });
                            }}
                          >
                            <div className="img-reciente">
                              <img
                                src={mostrarImagenReciente(reciente)}
                                className="top-imgreciente"
                                alt={reciente.imagen}
                              />
                            </div>
                            <div className="content-lblreciente">
                              <label className="lbl-descripcionreciente">
                                {reciente.nombre_componente}
                              </label>
                              <label className="lbl-descripcionreciente-text">
                                {reciente.nombre}
                              </label>
                              <hr className="hr-propiedades" />
                            </div>
                          </div>
                        );
                      })
                    : ""}
                </div>
              </Container>
              <Container className="conten-tematicas">
                <div>
                  <label className="lbl-lomasreciente">Temáticas </label>
                  <label className="lbl-contentdestacadosimple">
                    Datos abiertos
                  </label>
                  <div className="content-tematicasborder">
                    <label className="lbl-tematicasborde"></label>
                  </div>
                </div>
                <div className="mt-5">
                  <div className="corrousel-destacado">
                    <Swiper
                      navigation={true}
                      modules={[Navigation]}
                      style={{
                        "--swiper-navigation-size": "25px",
                      }}
                      slidesPerView={
                        infoHome?.resultTematicas?.length < 6
                          ? infoHome?.resultTematicas?.length
                          : 6
                      }
                      className="mySwiper"
                      spaceBetween={5}
                      breakpoints={{
                        200: {
                          slidesPerView: 1,
                          spaceBetween: 30,
                        },
                        320: {
                          slidesPerView: 1,
                          spaceBetween: 50,
                        },
                        600: {
                          slidesPerView: 2,
                          spaceBetween: 50,
                        },
                        1000: {
                          slidesPerView:
                            infoHome?.resultTematicas?.length < 6
                              ? infoHome?.resultTematicas?.length
                              : 6,
                          spaceBetween: 5,
                        },
                      }}
                    >
                      {infoHome?.resultTematicas?.length > 0
                        ? infoHome?.resultTematicas?.map((tematica, index) => {
                            return (
                              <SwiperSlide key={"slide-tematica-" + index}>
                                <div
                                  className="tamanocontenicontematicas container-fluid"
                                  key={index}
                                  onClick={() => {
                                    const url = componentes.filter(
                                      (componente) =>
                                        componente.nombre_componente ===
                                        "Datos abiertos"
                                    );
                                    navigate({
                                      pathname: url[0]?.url_componente,
                                      search: `?idTematica=${tematica.id_tematica}`,
                                    });
                                  }}
                                >
                                  <label className="circulo-tematicas">
                                    <IconButton
                                      className="tamano-icono-tematicas"
                                      imagen={
                                        tematica.imagen
                                          ? `${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Tematicas/${tematica.id_tematica}/${tematica.imagen}`
                                          : `${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Tematicas/default.svg`
                                      }
                                    />
                                  </label>
                                  <label className="lbl-tematicas-carrusel">
                                    {tematica.nombre}
                                  </label>
                                </div>
                              </SwiperSlide>
                            );
                          })
                        : ""}
                    </Swiper>
                  </div>
                </div>
              </Container>
              <Container className="container-back-dark content-contenidodestacado">
                <Container className="content-contenidodestacadohijo">
                  <div className="content-detacados-hijo">
                    <label className="lbl-contentdestacado ">Contenidos </label>
                    <label className="lbl-contentdestacadosimple ml-5">
                      Destacados
                    </label>
                    <div className="content-tematicasborder">
                      <label className="lbl-destacadosborder"></label>
                    </div>
                  </div>
                  <div className="espacio-tarjetas-destacados">
                    <Swiper
                      navigation={true}
                      modules={[Navigation]}
                      slidesPerView={
                        infoHome?.resultDestacado?.length < 4
                          ? infoHome?.resultDestacado?.length
                          : 4
                      }
                      className="mySwiper"
                      style={{
                        "--swiper-navigation-size": "25px",
                      }}
                      spaceBetween={5}
                      breakpoints={{
                        200: {
                          slidesPerView: 1,
                          spaceBetween: 30,
                        },
                        320: {
                          slidesPerView: 1,
                          spaceBetween: 50,
                        },
                        600: {
                          slidesPerView: 2,
                          spaceBetween: 50,
                        },
                        1000: {
                          slidesPerView:
                            infoHome?.resultDestacado?.length < 4
                              ? infoHome?.resultDestacado?.length
                              : 4,
                          spaceBetween: 4,
                        },
                      }}
                    >
                      {infoHome?.resultDestacado?.length > 0
                        ? infoHome?.resultDestacado?.map((destacado, index) => {
                            return (
                              <SwiperSlide key={"slide-destacado-" + index}>
                                <Container
                                  className="content-tarjetas-detcados primertrajeta-destacado"
                                  key={destacado.id}
                                >
                                  <div className="barra-vertical"></div>
                                  <div className="content-lbl-titulo-destacados">
                                    <div>
                                      <label className="lbl-destacado-trajeta">
                                        {destacado?.nombre}
                                      </label>
                                      <span className="span-tipo-destacado">
                                        {destacado?.tipo}{" "}
                                      </span>
                                      <label
                                        className="lbl-destacado-tarjeta-descripcion"
                                        title={destacado.descripcion}
                                      >
                                        {destacado?.descripcion}
                                      </label>
                                    </div>
                                    <div>
                                      {destacado?.tipo === "Documentación" ||
                                      destacado?.tipo === "ayuda" ? (
                                        <a
                                          className="btn-descargar-destacado"
                                          href={destacado.vinculo}
                                          target="_blank"
                                          rel="noreferrer"
                                          download=""
                                        >
                                          <Button className="btn-ira-tarjeta-destacados">
                                            DESCARGAR
                                          </Button>
                                        </a>
                                      ) : (
                                        <Button
                                          className="btn-ira-tarjeta-destacados"
                                          onClick={() => {
                                            if (destacado.vinculo) {
                                              window.open(
                                                `${destacado.vinculo}`,
                                                "_blank"
                                              );
                                            }
                                          }}
                                        >
                                          IR A
                                        </Button>
                                      )}
                                    </div>
                                  </div>
                                </Container>
                              </SwiperSlide>
                            );
                          })
                        : ""}
                    </Swiper>
                  </div>
                </Container>
              </Container>
              <Container className="content-contenidodestacado">
                <Container className="content-contenidodestacadohijo">
                  <div className="content-detacados-hijo">
                    <label className="lbl-contentdestacado ">Gestión </label>
                    <label className="lbl-contentdestacadosimple ml-5">
                      Información Geográfica
                    </label>
                    <div className="content-tematicasborder">
                      <label className="lbl-destacadosborder"></label>
                    </div>
                  </div>
                  <div className="espacio-tarjetas-destacados">
                    <Swiper
                      navigation={true}
                      modules={[Navigation]}
                      slidesPerView={
                        infoHome?.resultGestionGeografica?.length < 4
                          ? infoHome?.resultGestionGeografica?.length
                          : 4
                      }
                      className="mySwiper"
                      style={{
                        "--swiper-navigation-size": "25px",
                      }}
                      spaceBetween={5}
                      breakpoints={{
                        200: {
                          slidesPerView: 1,
                          spaceBetween: 30,
                        },
                        320: {
                          slidesPerView: 1,
                          spaceBetween: 50,
                        },
                        600: {
                          slidesPerView: 2,
                          spaceBetween: 50,
                        },
                        1000: {
                          slidesPerView:
                            infoHome?.resultGestionGeografica?.length < 4
                              ? infoHome?.resultGestionGeografica?.length
                              : 4,
                          spaceBetween: 4,
                        },
                      }}
                    >
                      {infoHome?.resultGestionGeografica?.length > 0
                        ? infoHome?.resultGestionGeografica?.map(
                            (destacado, index) => {
                              return (
                                <SwiperSlide key={"slide-destacado-" + index}>
                                  <Container
                                    className="content-tarjetas-detcados primertrajeta-destacado"
                                    key={destacado.id}
                                  >
                                    <div className="barra-vertical"></div>
                                    <div className="content-lbl-titulo-destacados">
                                      <div>
                                        <label className="lbl-destacado-trajeta">
                                          {destacado?.nombre}
                                        </label>
                                        <span className="span-tipo-destacado">
                                          {destacado?.tipo}{" "}
                                        </span>
                                        <label
                                          className="lbl-destacado-tarjeta-descripcion"
                                          title={destacado.descripcion}
                                        >
                                          {destacado?.descripcion}
                                        </label>
                                      </div>
                                      <div>
                                        {destacado?.tipo === "Documentación" ||
                                        destacado?.tipo === "ayuda" ? (
                                          <a
                                            className="btn-descargar-destacado"
                                            href={destacado.vinculo}
                                            target="_blank"
                                            rel="noreferrer"
                                            download=""
                                          >
                                            <Button className="btn-ira-tarjeta-destacados">
                                              DESCARGAR
                                            </Button>
                                          </a>
                                        ) : (
                                          <Button
                                            className="btn-ira-tarjeta-destacados"
                                            onClick={() => {
                                              if (destacado.vinculo) {
                                                window.open(
                                                  `${destacado.vinculo}`,
                                                  "_blank"
                                                );
                                              }
                                            }}
                                          >
                                            IR A
                                          </Button>
                                        )}
                                      </div>
                                    </div>
                                  </Container>
                                </SwiperSlide>
                              );
                            }
                          )
                        : ""}
                    </Swiper>
                  </div>
                </Container>
              </Container>

              <div className="flex-visitas_web">
                <MdPhonelink color="#333333" size={"35px"} className="mx-3" />
                <span className="number-visitas mx-3">{visitas}</span>
                <span className="mx-2">Visitas</span>
              </div>
            </div>
          </>
        )}
      </Container>
    </>
  );
}
